export default "__VITE_ASSET__BjmMkCsT__"